// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AlterarBloqueioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/alterar_bloqueio
 *
 * Validates input for updating an agenda bloqueio.
 * Only the fields needed by bloqueios_agenda_model::update_bloqueio().
 */
import { registerContract } from './validate'

export interface Agenda_AlterarBloqueioInput {
bloqueio_agenda_id: number
bloqueio_agenda_titulo: string
bloqueio_agenda_operador_user_id: string
bloqueio_agenda_data_hora_inicio: string
bloqueio_agenda_data_hora_fim: string
}

registerContract('Agenda_AlterarBloqueioInput', {
  bloqueio_agenda_id:               { type: 'number',  required: true },
  bloqueio_agenda_titulo:           { type: 'string',  required: true },
  bloqueio_agenda_operador_user_id: { type: 'string',  required: true },
  bloqueio_agenda_data_hora_inicio: { type: 'string',  required: true },
  bloqueio_agenda_data_hora_fim:    { type: 'string',  required: true },
})
